import { useEffect, useState } from 'react'

import { useAuth0 } from '@auth0/auth0-react'

const useUser = () => {
  const { user, isAuthenticated, getIdTokenClaims } = useAuth0()
  const [idTokenClaims, setIdTokenClaims] = useState(null)
  const [supabaseToken, setSupabaseToken] = useState(null)

  useEffect(() => {
    if (isAuthenticated) {
      const fetchIdTokenClaims = async () => {
        try {
          const claims = await getIdTokenClaims()
          setIdTokenClaims(claims)
        } catch (error) {
          console.error('Error fetching ID token claims:', error)
        }
      }

      fetchIdTokenClaims()
    }
  }, [isAuthenticated, getIdTokenClaims])

  return { user, idTokenClaims, setIdTokenClaims, supabaseToken, setSupabaseToken }
}

export default useUser
